/**
 *
 * Asynchronously loads the component for ConfirmModal
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
